module.exports = __webpack_public_path__ + "img/user.005e62f2.png";